module.exports = __webpack_public_path__ + "static/media/foodndrinks_anchorage_marker.a39b491c.svg";